import React from 'react';
import clsx from 'clsx';

import styles from './IconTooltip.module.scss';
import Icon from './Icon';
import Tail from './Tail';
import { COLOR_PALETTE } from '../api/portletConfiguration';

export default function IconTooltip({ service }) {
	const [showTooltip, setShowTooltip] = React.useState(false);
	//const tooltipRef = React.useRef();
	let tailColor =
		COLOR_PALETTE && COLOR_PALETTE['--axa-locator-primary-alt']
			? COLOR_PALETTE['--axa-locator-primary-alt']
			: '#2c2ec2';

	return (
		<div
			className={clsx(styles.root)}
			onMouseOver={() => setShowTooltip(true)}
			onMouseLeave={() => setShowTooltip(false)}
		>
			<Icon icon={service.icon} size="large" />
			<div
				className={clsx(
					styles.tooltip,
					showTooltip ? styles.show : null
				)}
			>
				<Icon icon="icon/info_white.png" size="large" textOn="right" />
				{service.tooltip}
				<Tail
					color={tailColor}
					direction="up"
					className={styles.tail}
				/>
			</div>
		</div>
	);
}
